<div class="text-center my-2">
  <a *ngIf="!isCompleted" [routerLink]="['/']" class="me-2 btn btn-primary"><i class="fa fa-list"></i>Cancel</a>

</div>

<app-protection-of-data-modal
(deleteConfirmFinished)="deleteOrNotDelete($event)">

</app-protection-of-data-modal>
<div *ngIf="!isCompleted">
<div class="row">
  <div class="col-sm-3"></div>
  <div class="col-sm-6 text-center" >
    <h3>Data Deletion Request Page</h3>
    <p>Enter the username whose details you want to be deleted. A confirmation email (if you registered by email) or verification code (if you registered by phone number) will be sent to you. After confirmation, all account details will be deleted after 30 days.</p>
    </div>
    <div class="col-sm-3"></div>
</div>
<form [formGroup] = "myForm" (ngSubmit)="on_submit()" class="form" enctype="multipart/form-data" *ngIf="!loading||!isSaving">



  <div class="form-group row mt-2" [ngClass]="{error:f.username.errors && f.username.touched}" >
    <div class="col-sm-3"></div>
      <label for="subjectId" class='control-label col-sm-2' >Username</label>
      <div class=" col-sm-3">
            <input type="text" id="username" formControlName="username" class="form-control" >
      </div>
      <div class="col-sm-4"></div>
      <div *ngIf="f.username.errors && f.username.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
      <ul><li>Invalid username</li></ul>
      </div>
    </div>

<div class="text-center">
  <button [disabled]="isSaving" type="submit" class="btn btn-primary mt-3 text-center">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
      Submit
  </button>
</div>

</form>
</div>

<hr/>
<app-country-level-syllabus></app-country-level-syllabus>
